import R from 'ramda'

const LIKE_OR_RETWEET_DISPLAY_NAME = 'Like OR Retweet'
const INITIAL_TWEET_TRIGGER_TYPE = 'INITIAL_TWEET'
const LIKE_OR_RETWEET_TRIGGER_TYPE = 'LIKE_OR_RETWEET'

const isLikeOrRetweetFormTrigger = R.propEq(
  'type',
  LIKE_OR_RETWEET_DISPLAY_NAME
)

const getTriggerType = R.cond([
  [R.propEq('action', 'NEW_TWEET'), R.always(INITIAL_TWEET_TRIGGER_TYPE)],
  [R.propEq('action', 'EXISTING_TWEET'), R.always(LIKE_OR_RETWEET_TRIGGER_TYPE)]
])

const getResult = R.cond([
  [R.propEq('action', 'NEW_TWEET'), R.always(LIKE_OR_RETWEET_TRIGGER_TYPE)]
])

const convertLikeOrRetweetFormTriggerToWidgetTrigger = R.applySpec({
  type: getTriggerType,
  result: getResult,
  data: R.prop('value'),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  operator: R.always('AND'),
  primary: R.T,
  isPromotedTweet: R.prop('isPromotedTweet')
})

export {
  isLikeOrRetweetFormTrigger,
  convertLikeOrRetweetFormTriggerToWidgetTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/form-to-widget/like_or_retweet.js